import React from 'react';
import './PriceGuarantee.scss';
import {Icon} from "../icon/Icon";

function PriceGuarantee(props){

	return (
		<div className={'price-guarantee box'}>
			<div className={'price-guarantee__headline ts-handwriting h1'}>Garantiert unschlagbares Angebot</div>
			<div className={'price-guarantee__delimiter'}></div>

			<div className={'price-guarantee__card-wrapper'}>
				<div className={'price-guarantee__card'}>
					<div className={'price-guarantee__icon'}><Icon name={'check-match'}/></div>
					<div className={'price-guarantee__subheadline ts-copy-small ts-bold'}>Wir entwerfen Reisen nach Maß
					</div>
					<div className={'price-guarantee__copy ts-copy-small'}>Wir sind konstant in unseren Reiseregionen unterwegs. So stellen wir aus erster Hand sicher, dass unser Angebot perfekt zu Ihren Bedürfnissen passt.
					</div>
				</div>

				<div className={'price-guarantee__card'}>
					<div className={'price-guarantee__icon'}><Icon name={'check-match'}/></div>
					<div className={'price-guarantee__subheadline ts-copy-small ts-bold'}>Geprüfte Qualität und optimaler Preis
					</div>
					<div className={'price-guarantee__copy ts-copy-small'}>In Ihr Angebot fließen über 40 Jahre Erfahrung. Durch vertrauensvolle Partnerschaften vor Ort erreichen wir die beste Qualität zum optimalen Preis für Sie.
					</div>
				</div>

				<div className={'price-guarantee__card'}>
					<div className={'price-guarantee__icon'}><Icon name={'check-match'}/></div>
					<div className={'price-guarantee__subheadline ts-copy-small ts-bold'}>Mit uns können Sie reden</div>
					<div className={'price-guarantee__copy ts-copy-small'}>Unsere Beratung ist von Menschen für Menschen. Sollten Sie ein vergleichbares Angebot finden, das Sie für besser halten, sprechen Sie uns gerne darauf an.
					</div>
				</div>
			</div>
		</div>

	)
}

export {
	PriceGuarantee as default,
	PriceGuarantee
}

